export default [
  {
    id: 'design-profile',
    title: '프로필',
    previewJumpId: 'close-preview-button-above'
  },
  {
    id: 'address',
    title: '주소',
    previewJumpId: 'close-preview-button-above'
  },
  {
    id: 'contacts',
    title: '연락처',
    previewJumpId: 'close-preview-button-above'
  },
  {
    id: 'id-photo',
    title: '증명사진',
    previewJumpId: 'close-preview-button-above'
  },
  {
    id: 'job-category',
    title: '직종',
    previewJumpId: 'close-preview-button-above'
  },
  {
    id: 'edu-history',
    title: '학력',
    previewJumpId: 'close-preview-button-above'
  },
  {
    id: 'skills',
    title: '스킬',
    previewJumpId: 'preview-page-02'
  },
  {
    id: 'license-history',
    title: '면허・자격증',
    previewJumpId: 'preview-page-02'
  },
  {
    id: 'job-history',
    title: '이력',
    previewJumpId: 'close-preview-button-above'
  },
  {
    id: 'mypr',
    title: '자기소개',
    previewJumpId: 'preview-page-02'
  },
  {
    id: 'hobby',
    title: '취미',
    previewJumpId: 'preview-page-02'
  },
  {
    id: 'create-date',
    title: '작성일',
    previewJumpId: 'close-preview-button-above'
  },
  {
    id: 'confirm',
    title: '확인',
    previewJumpId: 'confirm-preview'
  },
  {
    id: 'output',
    title: '다운로드',
    previewJumpId: 'close-preview-button-above'
  }
]
